// extracted by mini-css-extract-plugin
export var anchor = "autoOverview-module--anchor--24032";
export var root = "autoOverview-module--root--72a79";